import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown, MenuItem, Panel } from 'react-bootstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBuilding } from '@fortawesome/pro-solid-svg-icons';

import SurveyProperty from './survey_property';
import SurveyCsvExporter from './survey_csv_exporter';
import UnstyledDropdownToggle from 'components/bootstrap_extensions/unstyled_dropdown_toggle';
import CsvDownloadButton from  'components/csv_download_button';

const TABS = {
  potential: 0,
  rejected: 1
};

export default class SurveyTab extends React.Component {
  static propTypes = {
    addBuySurveyPropertyPath: PropTypes.string,
    addLeaseSurveyPropertyPath: PropTypes.string,
    projectId: PropTypes.number,
    removeSurveyProperty: PropTypes.func.isRequired,
    surveyProperties: PropTypes.array.isRequired,
    surveyPropertyCsvColumns: PropTypes.object,
    surveysPath: PropTypes.string,
    toggleReject: PropTypes.func.isRequired
  }

  state = {
    exportingCsv: false,
    tab: TABS.potential
  }

  switchTab = (tab) => {
    this.setState({ tab });
  }

  activeProperties = () => {
    return this.props.surveyProperties.filter((property) => {
      return property.rejected === false;
    });
  }

  surveyProperties = () => {
    return this.props.surveyProperties.filter((property) => {
      return property.rejected === (this.state.tab !== TABS.potential);
    });
  }

  renderAddSurveyPropertyButton() {
    if (this.props.addBuySurveyPropertyPath && this.props.addLeaseSurveyPropertyPath) {
      return (
        <Dropdown id="addSurveyPropertyDropdown">
          <UnstyledDropdownToggle bsRole="toggle" className="btn btn-create">
            Add New Location
          </UnstyledDropdownToggle>

          <Dropdown.Menu>
            <MenuItem
              eventKey="1"
              href={this.props.addLeaseSurveyPropertyPath}
              name="addSurveyPropertyLink"
            >
              Lease Location
            </MenuItem>
            <MenuItem
              eventKey="2"
              href={this.props.addBuySurveyPropertyPath}
              name="addSurveyPropertyLink"
            >
              Buy Location
            </MenuItem>
          </Dropdown.Menu>
        </Dropdown>
      );
    }

    return (
      <React.Fragment>
        {this.props.addLeaseSurveyPropertyPath &&
          <a
            className="btn btn-create"
            href={this.props.addLeaseSurveyPropertyPath}
            name="addSurveyPropertyLink"
          >
            Add Lease
          </a>
        }
        {this.props.addBuySurveyPropertyPath &&
          <a
            className="btn btn-create"
            href={this.props.addBuySurveyPropertyPath}
            name="addSurveyPropertyLink"
          >
            Add Buy
          </a>
        }
      </React.Fragment>
    );
  }

  renderHeader() {
    const potentialClassName = this.state.tab === TABS.potential ? 'active' : '';
    const rejectedClassName = this.state.tab === TABS.potential ? '' : 'active';

    return (
      <React.Fragment>
        <div className="header row-eq-height my-2">
          <h2 className="my-0 grow">Survey</h2>
          <CsvDownloadButton entityName='surveys' onClick={() => this.setState({ exportingCsv: true })}/>
          {this.renderAddSurveyPropertyButton()}
        </div>
        <ul className='nav nav-pills muted mb-2'>
          <li className={potentialClassName}>
            <a
              href='#'
              name='potential-locations'
              onClick={(e) => {
                e.preventDefault();
                this.switchTab(TABS.potential);
              }}
            >
              Potential Locations
            </a>
          </li>
          <li className={rejectedClassName}>
            <a
              href='#'
              name='rejected-locations'
              onClick={(e) => {
                e.preventDefault();
                this.switchTab(TABS.rejected);
              }}
            >
              Rejected Locations
            </a>
          </li>
        </ul>
      </React.Fragment>
    );
  }

  renderEmptyState() {
    return (
      <div className="form-column top-buffer-md" name="emptySurveyPropertyList">
        <div className="text-center no-survey-properties-found bottom-buffer-md pt-5">
          <FontAwesomeIcon className="light-blue-icon" icon={faBuilding} size="6x"/>
          <h3>
            You don't have any locations yet!
          </h3>
          <h4 className="text-muted">
            Click "Add Location" to add your first location.
          </h4>
        </div>
      </div>
    );
  }

  renderSurveyProperties() {
    if (this.surveyProperties().length === 0) {
      return this.renderEmptyState();
    }
    return this.surveyProperties().map((property) => {
      return (
        <SurveyProperty
          key={property.id}
          name='survey-property-row'
          projectId={this.props.projectId}
          property={property}
          removeSurveyProperty={this.props.removeSurveyProperty}
          toggleReject={this.props.toggleReject}
        />
      );
    });
  }

  renderCsvExporter() {
    return (
      <Panel>
        <Panel.Body>
          <SurveyCsvExporter
            surveyPropertyCount={this.activeProperties().length}
            surveyPropertyCsvColumns={this.props.surveyPropertyCsvColumns}
            surveysPath={this.props.surveysPath}
            onCancel={() => this.setState({ exportingCsv: false })}
          />
        </Panel.Body>
      </Panel>
    );
  }

  render() {
    if (this.state.exportingCsv) return this.renderCsvExporter();
    return (
      <Panel>
        <Panel.Body>
          <div className='mb-4'>
            {this.renderHeader()}
          </div>
          {this.renderSurveyProperties()}
        </Panel.Body>
      </Panel>
    );
  }
}
